import React, { useEffect, useState } from 'react'
import Button from '../../component/Button'
import classes from "./style.module.scss";
import UserRetailRequest from './components/UserRetailRequest';
import GenerateSlot from '../../modalComponents/GenerateSlot';
import UserDetails from './components/UserDetails';
import { useLocation } from 'react-router-dom';
import SearchBox from '../../component/SearchBox';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField } from '@mui/material';
import dayjs from 'dayjs';

const ReportDownload = () => {
  const BY_USERS = 'By Users'
  const BY_DATE = 'By Date'
  const BY_POINTS = 'By Points'

  const USERLIST = [BY_USERS,BY_DATE,BY_POINTS];
  const [searchInput, setSearchInput] = useState('')
  const [activeTab, setActiveTab] = useState(BY_USERS)
  const [showPopUp, setShowPopUp] = useState(false)
  const [viewData, setViewData] = useState(null)
  const [userInfo, setUserInfo] = useState(false)
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [dateSearched, setDateSearched] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setSearchInput('')
    setViewData(null)
    setDateSearched(false)
    setStartDate(null); 
    setEndDate(null); 
  }, [activeTab])

  useEffect(() => {
    if (location?.pathname) {
      const params = getUserId()
      if (params) {
        setUserInfo(true)
      } else {
        setUserInfo(false)
      }
    }
  }, [location])

  const getUserId = () => {
    const pathName = location?.search?.split('?id=')
      const params = pathName[pathName?.length - 1]
      return params
  }

  const handleChange = (value) => {
    setSearchInput(value)
  }

  const handleFindClick = () => {
    if (startDate && endDate) {
      setDateSearched(true)
    }
  }

  // const getActiveTab = () => {
  //   let userRole = {};
  //   // if (activeTab === NEW_RETAIL) {
  //   //   userRole['role'] = 2
  //   //   userRole['type'] = 'new_user'
  //   // } else if (activeTab === VERIFIED_RETAIL) {
  //   //   userRole['role'] = 2
  //   //   userRole['type'] = 'verfied_retailers'
  //   // } else if(activeTab == INCOMPLETE_RETAIL) {
  //   //   userRole['role'] = 2
  //   //   userRole['isApprovedByFilter'] = 2
  //   // } else if(activeTab == INCOMPLETE_MECHANIC) {
  //   //   userRole['role'] = 3
  //   //   userRole['isApprovedByFilter'] = 2
  //   // } else if(activeTab == REJECTED_RETAILER) {
  //   //   userRole['role'] = 2
  //   //   userRole['type'] = 'rejected_retailers'
  //   // } else if(activeTab == COMPLETE_MECHANIC) {
  //   //   userRole['role'] = 3
  //   //   userRole['type'] = 'completed_mechanics'
  //   // } else if(activeTab == RETAILERS_WITHOUT_TARGET) {
  //   //   userRole['role'] = 2
  //   //   userRole['type'] = 'retailers_without_target'
  //   // } else {
  //     userRole['role'] = null
  //     userRole['type'] = null
  //   // }
  //   return userRole
  // }

  const getActiveTab = () => {
    let userRole = {};

    if (activeTab === BY_POINTS) {
        userRole['points'] = true
        userRole['type'] = BY_POINTS

        // Add date range for By Points if available and searched
        if (dateSearched) {
            if (startDate) {
                userRole['startDate'] = dayjs(startDate).format('YYYY-MM-DD')
            }
            if (endDate) {
                userRole['endDate'] = dayjs(endDate).format('YYYY-MM-DD')
            }
        }
    } else if (activeTab === BY_DATE && dateSearched) {
      userRole['type'] = BY_DATE
        // Add date range params if available and searched
        if (startDate) {
            userRole['startDate'] = dayjs(startDate).format('YYYY-MM-DD')
        }
        if (endDate) {
            userRole['endDate'] = dayjs(endDate).format('YYYY-MM-DD')
        }
    } else {
        // By Users tab
        userRole['role'] = null
        userRole['type'] = BY_USERS
    }

    return userRole
}

  const shouldShowUserList = activeTab === BY_USERS || (activeTab === BY_DATE && dateSearched) || (activeTab === BY_POINTS && dateSearched);
   return (
    <>
      {userInfo ?
        <UserDetails viewData={viewData} userId={getUserId()} currentTab={activeTab} />
        :
        <div className={`${classes.manageUserWrapper}`}>
          <div className={`w-[100%] flex items-center justify-between`}>
            <div className={`layout-title`}>Manage Users</div>
            <div className='flex items-center gap-4'>
              {activeTab !== BY_USERS   && (
                <>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Start Date"
                      value={startDate}
                      onChange={(newValue) => setStartDate(newValue)}
                      slotProps={{ textField: { size: 'small' } }}
                    />
                    <DatePicker
                      label="End Date"
                      value={endDate}
                      onChange={(newValue) => setEndDate(newValue)}
                      minDate={startDate}
                      slotProps={{ textField: { size: 'small' } }}
                    />
                  </LocalizationProvider>
                  <Button
                    text="Find"
                    onClick={handleFindClick}
                    disabled={!startDate || !endDate}
                    style={{     
                      lineHeight: "normal",
                      height: "40px",
                      padding: "0px 20px",
                      fontSize: "16px", }}
                  />
                </>
              )}
              
                <SearchBox
                  className={''}
                  value={searchInput}
                  onChange={handleChange}
                  placeholder={'Find by name and email'}
                />
             
            </div>
          </div>
          <div className={`${classes.userHeaderList} w-[100%] flex items-center cursor-pointer`}>
            {USERLIST?.map((title) => (
              <div
                key={title}
                className={`${classes.userTab} ${activeTab === title ? classes.activeTab : ''}`}
                onClick={() => setActiveTab(title)}
              >
                {title}
              </div>
            ))}
          </div>
          <div>
            {shouldShowUserList && (
              <UserRetailRequest
                activeTab={getActiveTab()}
                searchInput={searchInput}
                setViewData={setViewData}
              />
            )}
            {activeTab !== BY_USERS && !dateSearched && (
              <div className="text-center py-8 text-gray-600">
                Please select start and end dates and click Find to view results
              </div>
            )}
          </div>
        </div>
      }
      {showPopUp ?
        <GenerateSlot isOpen={showPopUp} closePopUp={setShowPopUp} />
        : null
      }
    </>
  )
}

export default ReportDownload